import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material";
import { HttpErrorResponse } from "@angular/common/http";
import { CoreErrorDialogComponent } from "./errordialog.component";
import {
	PosSharedService,
	posEventName
} from "src/app/components/pos/shared/pos.shared.services";
import { LocalStorageKey } from "@royalty/model";
import { CoreToolbox } from "src/app/core/utils/core-toolbox";

@Injectable()
export class ErrorDialogService {
	public isDialogOpen: Boolean = false;
	constructor(
		private dialog: MatDialog,
		private posShareService: PosSharedService
	) {}
	openDialog(httpResponse: HttpErrorResponse) {
		if (httpResponse && httpResponse.status !== null) {
			if (httpResponse.status.toString().indexOf("401") > -1) {
				const hasToken = CoreToolbox.storageService.getItem(
					LocalStorageKey.access_token
				);
				if (this.isDialogOpen || !hasToken) {
					return false;
				}
				this.isDialogOpen = true;
				this.dialog
					.open(CoreErrorDialogComponent, {
						data: httpResponse
					})
					.afterClosed()
					.subscribe((isOk: boolean) => {
						if (isOk) {
							this.isDialogOpen = false;
							this.posShareService.setObservable(
								posEventName.unAuthorize,
								true
							);
						}
					});
			}
		}
	}
}
